






















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class StListWrap extends Vue {
    private visible: boolean = true;

    @Prop()headerColor!: string;
    @Prop()collapseMode!: boolean;
    @Prop()defaultCollapsed!: boolean;

    get isVisible(){
        return this.visible || !this.collapseMode;
    }

    toggleVisible(){
        if(this.collapseMode){
            this.visible = !this.visible;
        }
    }

    created(){
        this.visible = !this.defaultCollapsed;
    }

    get getHeaderColor(){
        if(!this.headerColor){
            return 'bg-green-500 text-gray-900';
        }

        return this.headerColor;
    }
}
